export const Z_INDEX_FOR_ADD_BUTTONS = 1100;
export const DEFAULT_BOTTOM_MARGIN_FOR_ADD_BUTTONS = 16;
